const state = {
  tab: 0,
  roundsTableLoading: false,
  screensTableLoading: false,
  groupsTableLoading: false,
  lastEvalKey: 1,
  tempSessions: [],
  reportsScreens: [],
  chartData: {
    foodAndBeverage: 0,
    rentalData: {
      data: [0, 0],
      labels: ['1-way', 'Round Trip'],
    },
    listenData: [{ avg: 0 }, { avg: 0 }, { avg: 0 }],
    watchData: [
      {
        data: [0, 0, 0],
        labels: ['PGA', 'Yahoo', 'Greg Norman Experience'],
      },
    ],
    dynamicYardage: {
      data: [0],
      labels: ['Dyanmic Yards'],
      raw: 0,
      total: 0,
    },
    scoreCardData: {
      data: [0, 0],
      labels: ['Scorecard Used', 'Scorecard Not Used'],
    },
    chargedOffRentalData: {
      data: [0, 0],
      labels: ['1-way', 'Round Trip'],
    },
    deviceUtilization: {
      labels: [],
      data: [
        {
          name: 'Utilization',
          data: [],
        },
      ],
      title: 'Utilization',
    },
    rentalsByDay: {
      data: [
        {
          data: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
          ],
        },
      ],
      labels: ['12PM', '8PM', '4AM', '11AM'],
    },
    rentalsByWeek: {
      data: [
        {
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
      labels: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    },
    deviceOverview: {
      data: [44, 97],
      labels: ['Checked Out', 'Checked In'],
    },
    liteVsFull: {
      data: [78, 23],
      labels: ['Full', 'Lite'],
    },
    checkedIn: {
      data: [0, 0],
      labels: ['Checked In', 'Checked Out'],
    },
  },
  screens: [],
  sessions: {},
  chargedOffSessions: {},
  groups: {},
  export: false, // modal boolean
  queryParams: {
    page: 1,
    search: '',
  },
  exportData: {
    rentals: {
      title: 'RENTALS REPORT',
      fields: [
        {
          text: 'Device ID',
          selected: true,
        },
        {
          text: 'RA#',
          selected: true,
        },
        // {
        //   text: "Originating Location",
        //   selected: true
        // },
        // {
        //   text: "Destination Location",
        //   selected: true
        // },
        {
          text: 'Rental Type',
          selected: true,
        },
        {
          text: 'Rental Start Date',
          selected: true,
        },
        {
          text: 'Rental End Date',
          selected: true,
        },
        // {
        //   text: "Number of Rental Days",
        //   selected: true
        // },
        // {
        //   text: "Rental Revenue",
        //   selected: true
        // }
      ],
    },
    chargedOff: {
      title: 'CHARGED OFF REPORT',
      fields: [
        {
          text: 'Device ID',
          selected: true,
        },
        {
          text: 'RA#',
          selected: true,
        },
        // {
        //   text: "Originating Location",
        //   selected: true
        // },
        // {
        //   text: "Destination Location",
        //   selected: true
        // },
        // {
        //   text: "Charged Off Date",
        //   selected: true
        // },
        {
          text: 'Rental Start Date',
          selected: true,
        },
        {
          text: 'Rental End Date',
          selected: true,
        },
        {
          text: 'Trip Type',
          selected: true,
        },
        // {
        //   text: "GroupContact(s)",
        //   selected: true
        // },
        // {
        //   text: "Call Status",
        //   selected: true
        // },
        // {
        //   text: "Notes",
        //   selected: true
        // }
      ],
    },
    utilization: {
      title: 'UTILIZATION REPORT',
      fields: [
        {
          text: 'Device ID',
          selected: true,
          field: 'device_id',
        },
        // {
        //   text: "Device Utiliztion",
        //   selected: true
        // },
        // {
        //   text: "Originating Location",
        //   selected: true
        // },
        // {
        //   text: "Destination Location",
        //   selected: true
        // },
        // {
        //   text: "Total Number Of Devices",
        //   selected: true
        // },
        // {
        //   text: "Checked In",
        //   selected: true
        // },
        // {
        //   text: "Checked Out",
        //   selected: true
        // },
        // {
        //   text: "1-Way",
        //   selected: true
        // },
        // {
        //   text: "Roundtrip",
        //   selected: true
        // },
        {
          text: 'Type',
          selected: true,
        },
        // {
        //   text: "Overdue",
        //   selected: true
        // },
        {
          text: 'Rental Start Date',
          selected: true,
        },
        {
          text: 'Rental End Date',
          selected: true,
        },
        // {
        //   text: "Avg Unique Rentals by Day of Week",
        //   selected: true
        // },
        // {
        //   text: "Avg Unique Rentals by Hour",
        //   selected: true
        // }
      ],
    },
    sharkRoundsReport: {
      title: 'CHARGED OFF REPORT',
      fields: [
        {
          text: 'Round ID',
          selected: true,
        },
        {
          text: 'Course Name',
          selected: true,
        },
        {
          text: 'Launch Mode',
          selected: true,
        },
        {
          text: 'Holes Played',
          selected: true,
        },
        {
          text: 'Shark Car ID',
          selected: true,
        },
        {
          text: 'GPSI Car #',
          selected: true,
        },
        {
          text: 'MDN',
          selected: true,
        },
        {
          text: 'Round Start',
          selected: true,
        },
        {
          text: 'Round End',
          selected: true,
        },
      ],
    },
  },
  sharkAnalytics: {
    dynamicYardage: {},
    watchTotals: {},
    listenTotals: {},
  },
  roundsPlayedChart: {
    chart: {},
    chartType: 'line',
    showOnMobile: true,
    type: 'line-chart',
    component: 'chart',
    data: [
      {
        data: [],
        name: '',
      },
    ],
  },
  launchModeChart: {
    chartType: 'bar',
    showOnMobile: true,
    type: 'bar-chart',
    component: 'chart',
    data: [
      {
        data: [],
        name: '',
      },
    ],
  },
  roundsLaunchChart: {
    chartType: 'bar',
    showOnMobile: true,
    type: 'bar-chart',
    component: 'chart',
    data: [0, 0, 0, 0, 0],
    labels: ['Prime', 'Select++', 'Select+', 'Select', 'Bluetooth', 'None'],
  },
  golfCarChart: {
    chartType: 'line',
    showOnMobile: true,
    type: 'line-chart',
    component: 'chart',
    data: [
      {
        data: [],
        name: '',
      },
    ],
  },
  totalCarsGraph: {},
  carsByModelGraph: {},
  totalGroupsGraph: {},
  groupsByModelGraph: {},
  cartsLaunchChart: {
    chartType: 'bar',
    showOnMobile: true,
    type: 'bar-chart',
    component: 'chart',
    data: [0, 0, 0, 0, 0],
    labels: ['Prime', 'Select++', 'Select+', 'Select', 'Bluetooth', 'None'],
  },
  sharkGroupsChart: {
    chartType: 'line',
    showOnMobile: true,
    type: 'line-chart',
    component: 'chart',
    data: [
      {
        data: [],
        name: '',
      },
    ],
  },
  groupsLaunchChart: {
    chartType: 'bar',
    showOnMobile: true,
    type: 'bar-chart',
    component: 'chart',
    data: [0, 0, 0, 0, 0],
    labels: ['Prime', 'Select++', 'Select+', 'Select', 'Bluetooth', 'None'],
  },
  exportURL: {
    csv: '',
    excel: '',
    loaded: false,
  },
  sharkRounds: {
    filter: {},
    rawData: [],
  },
  sharkScreens: {
    filter: {},
    rawData: [],
  },
  sharkGroups: {
    filter: {},
    rawGroupsData: [],
    rawRoundsData: [],
  },
  sharkAnalyticsData: {},
  sharkUniqueRentalData: {},
  rounds: [],
  dynamicYardageChart: {},
  scorecardChart: [],
  foodAndBeverageChart: [],
  listenChart: {},
  watchChart: {},
  graphLoadingStates: {
    roundsPlayed: true,
    foodAndBeverage: true,
    launchMode: true,
    dynamicYardage: true,
    scorecard: true,
    watch: true,
    listen: true,
  },
};
export default state;
